<template>
  <div>    
    <div class="widget-container">

      <DxForm
            :form-data="formData"
            label-mode='outside'
            :read-only='false'
            :show-colon-after-label='true'
            label-location='top'
            :min-col-width='300'
            :col-count='2'
            onInitialized="onInitialized"
            ref="formMaster"
      >

        <DxColCountByScreen :xs="1" :sm="1" :md="1" :lg="1"/>

        <DxGroupItem caption="" :col-span="2" :col-count="2">
            
                <DxSimpleItem 
                    data-field="expense_date"
                    :is-required="true"
                    :editor-options="datetimeBoxEditorOptions"
                    editor-type="dxDateBox"
                >
                  <DxLabel text="Ημερομηνία Εξόδου"/>
                </DxSimpleItem>

                <DxSimpleItem
                    data-field="expense_type_id"
                    editor-type="dxSelectBox"
                    :is-required="true"
                    :editor-options="{
                        dataSource: LookupCustomDS_ow_expense_types,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr:'id',
                        sort: 'name',
                        showClearButton: true,
                        onValueChanged: onExpenseTypeChange,
                    }"
                >
                    <DxLabel text="Τύπος Εξόδου"/>
                </DxSimpleItem>
  
                <DxSimpleItem
                    data-field="user_id"
                    editor-type="dxSelectBox"
                    :is-required="true"
                    searchEnabled = true
                    :editor-options="{
                        dataSource: LookupCustomDS_ow_view_technicians,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr:'id',
                        sort: 'name',
                        showClearButton: true,
                    }"
                >
                    <DxLabel text="Τεχνικός"/>
                </DxSimpleItem>

                <DxSimpleItem
                    data-field="total_value"
                    editor-type="dxNumberBox"
                    :editor-options="editorNumberBoxOptions"
                >
                    <DxLabel text="Σύνολο"/>
                </DxSimpleItem>

        </DxGroupItem>

        <DxSimpleItem 
            data-field="user_comment" 
            editor-type="dxTextArea" 
            :is-required="mandatoryCommentInd"
            :editor-options="{placeholder: 'Προσθήκη σχόλιου...', height: 75, rows: 10}"
        >
            <DxLabel :visible="true" text="Σχόλια" />
        </DxSimpleItem>

      </DxForm>

      <div id="buttons">
          <DxToolbar>
              <DxItem 
                  location="after"
                  widget="dxButton"
                  @click="onClickSave"
                  :options="{
                      icon: 'save',
                      text: 'Αποθηκευση'
                  }"
              >
              </DxItem>
              <DxItem 
                  location="after" 
                  widget="dxButton"
                  @click="onClickClose"
                  :options="{
                      icon: 'close',
                      text: 'Κλεισιμο'
                  }"
                  >
              </DxItem>
          </DxToolbar>
    </div>
    </div>
</div>
</template>

<script setup>

    const emit = defineEmits(['closePopupEvent'])

    import CustomStore from 'devextreme/data/custom_store';
    import {ref, watch, /*, reactive, computed, onMounted*/} from 'vue';

    import 'whatwg-fetch';

    import OParameters from '../es-globals';

    import {
        DxForm, 
        DxLabel,
        DxSimpleItem, 
        DxGroupItem,
        DxColCountByScreen,
    } from 'devextreme-vue/form'; 

    import {DxItem} from 'devextreme-vue/tab-panel'
    import DxToolbar from 'devextreme-vue/toolbar'

    var isInsertMode = false
    var isGridValidated = true
    //Form
    const URL_SERVICE = OParameters.Host.URI + 'ow_expenses'
    const URL_SERVICE_ow_expense_types = OParameters.Host.URI + 'ow_expense_types'
    const URL_SERVICE_LOOKUP_ow_view_technicians = OParameters.Host.URI + 'ow_view_technicians';
    

    const formMaster = ref(null)
    const formData = ref({})
    const mandatoryCommentInd = ref(false)

    watch(formData.value.id, (newValue, oldValue) => {
        console.log('Watch user_id-value-changed')
        emit('user_id-value-changed', newValue, oldValue)
        //loadFormData(newValue)
    })

    const editorNumberBoxOptions = {
        placeholder: 'Εισάγετε ποσό...',
        format: OParameters.methods.formatCurrencyNumber,
        showSpinButtons: true,
        step: 0.01
    }
    
    const datetimeBoxEditorOptions = {
        type: 'datetime',
        pickerType: 'rollers',
        displayFormat: 'dd/MM/yyyy HH:mm',
        dateSerializationFormat: 'yyyy-MM-dd HH:mm:ss',
        invalidDateMessage: 'Λάθος Ημερομηνία',
        showClearButton: true,
        //min: new Date(),
        max: new Date(2030, 11, 31),
    }

    const LookupCustomDS_ow_expense_types = new CustomStore({
          key: 'id',
          loadMode: 'raw',
          load: () => sendRequest(URL_SERVICE_ow_expense_types + '?order=name'),
    })

    const LookupCustomDS_ow_view_technicians = new CustomStore({
        key: 'id',
        loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE_LOOKUP_ow_view_technicians + '?order=name'),
        byKey: (key) => sendRequestByKey(URL_SERVICE_LOOKUP_ow_view_technicians + "/" + encodeURIComponent(key)),
    })
    
    const CustomStoreMain= new CustomStore({
        key: 'id',
        //loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE),
        insert: (values) => sendRequest(URL_SERVICE, 'POST', values),
        update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
        remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
        byKey: (key) => sendRequestByKey(URL_SERVICE + "/" + encodeURIComponent(key)),
    })
    
    // 
    //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
    //
    const sendRequest = (url, method = 'GET', values = {}) => {
          console.log('sendRequest START LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          if (method === 'GET') {
              return fetch(url, {
                  method,
                  credentials: 'include',
              })
              .then(response => response.json())
              .then(json => {
                  return json.records;
              })
          }
          return fetch(url, {
              method,
              body: JSON.stringify(values),
              headers: {'Content-Type': 'application/json',},
              credentials: 'include',
          }).then((result) => {
              if (result.ok) {
                  return result.text().then((text) => text && JSON.parse(text));
              }
              return result.json().then((json) => {
                  throw json.Message;
              });
          });
    }

    const sendRequestByKey = (url, method = 'GET') => {
        //console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
        return fetch(url, {
                  method,
                  headers: {
                      'Accept': 'application/json',
                  },
                  credentials: 'include',
              })
              .then(response => response.json())
    }
  
    const loadFormData = async (id) => {

        console.log('loadFormData', id);

        formData.value = {}
        if (id != null) {
            console.log('id != null', id);
            isInsertMode = false
            console.log('formData.value = {}', id);
            formData.value = await CustomStoreMain.byKey(id)
        } else {
            isInsertMode = true
            console.log('loadFormData isInsertMode = true');
            formData.value.user_group = []
        }
        console.log('formData.value.date_time');
        formData.value.date_time = new Date().toISOString().slice(0, 19).replace('T', ' ')
    }

    const onClickSave = async () => {
        
        const formValidator = formMaster.value.instance.validate()
        isGridValidated = true
        let formSaved = false

        if (formValidator.isValid) {
            if (!isInsertMode) {
                await saveData()
                formSaved = true
            } else {
                await insertData()
                formSaved = true
            }
        }

        if (isGridValidated && formSaved) emit('closePopupEvent', true)

    }

    const saveData = async () => {
        console.log('Save data');
        // build a one-off payload, leaving formData.value untouched
        const payload = {
            ...formData.value,
            user_group: JSON.stringify(formData.value.user_group)
        };
        // now call the CustomStore.update, which in turn will do your PUT
        return await CustomStoreMain.update(formData.value.id, payload);
        //return await CustomStoreMain.update(formData.value.id, formData.value);
    }

    const insertData = async () => {
        // console.log('Insert data');
        let data2store = {...formData}
        data2store.user_group = JSON.stringify(data2store.user_group)
        return await CustomStoreMain.insert(formData.value);
    }

    const onExpenseTypeChange = async (e) => {
      console.log('e', e)
        
        if (e.value !== null) {              
            const modelrow = await LookupCustomDS_ow_expense_types.byKey(e.value)
            mandatoryCommentInd.value =  modelrow.mandatory_comment_ind
            console.log('modelrow', mandatoryCommentInd.value)
        }
        
    }

    const onClickClose = () => {
        emit('closePopupEvent', true)
    }

    defineExpose({
        loadFormData
    });

</script>


<style lang="scss">

</style>

<style scoped>

#form {
   margin-top: 25px;
}
.caption {
    font-size: 18px;
    font-weight: 500;
}
.option {
    margin-top: 10px;
}
.dx-fieldset-header {
    font-size: 16px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
    padding-top: 10px;
    margin-top: 4px;
}
</style>
